import { useEffect, useState } from "react";
import { getZonaById, postZona, patchZona } from "../../services/ZonasServices";
import { postClienteZona, deleteClienteZona } from "../../services/ClientesZonasServices";
import { ZonasFormContext } from "./ZonasContext";
import { useNavigate, useParams } from 'react-router-dom';

export const ZonasFormState = ({ children }) => {
  const [report, setReport] = useState({});
  const [detalleClientesData, setDetalleClientesData] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) getZonaByIdData(id);
  }, [id]);

  async function getZonaByIdData(id) {
    let res = await getZonaById(id);
    if (res) setReport(res);
  }

  const postZonaData = async (body) => {
    try {
      const resZona = await postZona(body);

      // Si hay clientes para asignar a esta zona
      if (detalleClientesData.length > 0) {
        const zona_id = resZona.data.id;

        for (const cliente of detalleClientesData) {
          await postClienteZona({
            user_id: cliente.user_id,
            zona_id: zona_id,
            es_principal: cliente.es_principal || 1,
            asignacion: 'manual',
          });
        }
      }

      navigate("/zonas");

    } catch (error) {
      console.error("Error grabando zona:", error);
    }
  };

  const patchZonaData = async (id, body) => {
    try {
      await patchZona(id, body);

      // Si hay nuevos clientes para asignar
      if (detalleClientesData.length > 0) {
        for (const cliente of detalleClientesData) {
          if (cliente.isNew) {
            await postClienteZona({
              user_id: cliente.user_id,
              zona_id: id,
              es_principal: cliente.es_principal || 1,
              asignacion: 'manual',
            });
          }
        }
      }

      navigate("/zonas");

    } catch (error) {
      console.error("Error actualizando zona:", error);
    }
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // Manejo del array de clientes (detalle)
  // ═══════════════════════════════════════════════════════════════════════════

  const addItemToArray = (item) => {
    setDetalleClientesData((prev) => [...prev, { ...item, isNew: true }]);
  };

  const getItemFromArrayById = (id) => {
    return detalleClientesData.find((item) => String(item.id) === String(id)) || null;
  };

  const updateItemFromArray = (id, updatedFields) => {
    setDetalleClientesData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, ...updatedFields } : item
      )
    );
  };

  const removeItemFromArray = (id) => {
    setDetalleClientesData((prev) => prev.filter((item) => item.id !== id));
  };

  const clearArray = () => {
    setDetalleClientesData([]);
  };

  return (
    <ZonasFormContext.Provider value={{
      report,
      postZonaData,
      patchZonaData,
      detalleClientesData,
      addItemToArray,
      getItemFromArrayById,
      updateItemFromArray,
      removeItemFromArray,
      clearArray
    }}>
      {children}
    </ZonasFormContext.Provider>
  );
};
